@if (requestModel) {
  @if (showHeader) {
    <div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 py-2">
      <span class="fs-5 fw-700">{{ requestModel.movement?.name }}</span>
      <div class="d-flex align-items-center gap-3">
        <small class="text-muted" aria-label="Fecha de solicitud">
          <i class="fa fa-calendar-alt" aria-hidden="true"></i>
          {{ requestModel.dateRequest | date: "dd-MM-yyyy": "UTC" }}
        </small>
        <button type="button" class="close btn btn-sm btn-white" aria-label="Cerrar" (click)="dismiss()">&times;</button>
      </div>
    </div>
  }

  @if (!editRequest) {
    <div class="modal-body pt-0">
      @if (requestModel.insured) {
        <div class="p-3 text-dark">
          <span class="fs-6 fw-700 text-uppercase small">Datos Personales</span>
          <dl class="row my-2" aria-label="Datos personales del asegurado">
            <div class="col-lg-4 col-sm-6">
              <dt class="small fw-700">RUT</dt>
              <dd class="fw-semibold">{{ requestModel.insured.rut | numberPipe }}-{{ requestModel.insured.dv }}</dd>
            </div>
            <div class="col-lg-8 col-sm-6">
              <dt class="small fw-700">Nombre Completo</dt>
              <dd class="fw-semibold">{{ requestModel.insured.names }} {{ requestModel.insured.surname }} {{ requestModel.insured.lastname }}</dd>
            </div>
            <div class="col-lg-3 col-sm-6">
              <dt class="small fw-700">Género</dt>
              <dd class="fw-semibold">{{ requestModel.insured.gender?.code }} - {{ requestModel.insured.gender?.name }}</dd>
            </div>
            <div class="col-lg-3 col-sm-6">
              <dt class="small fw-700">Nacimiento</dt>
              <dd class="fw-semibold">{{ requestModel.insured.birthdate | date: 'dd-MM-yyyy': 'UTC' }}</dd>
            </div>
            <div class="col-lg-3 col-sm-6">
              <dt class="small fw-700">Edad</dt>
              <dd class="fw-semibold">{{ requestModel.insured.age }} años</dd>
            </div>
            <div class="col-lg-3 col-sm-6">
              <dt class="small fw-700">Teléfono</dt>
              <dd class="fw-semibold">{{ requestModel.insured.phone ? requestModel.insured.phone : "Sin registro" }}</dd>
            </div>
            <div class="col-lg-6 col-sm-12">
              <dt class="small fw-700">Correo</dt>
              <dd class="fw-semibold">{{ (requestModel.insured.mail == null || requestModel.insured.mail === '') ? "Sin registro" : requestModel.insured.mail | lowercase }}</dd>
            </div>
            <div class="col-lg-3 col-sm-6">
              <dt class="small fw-700">Tipo Asegurado</dt>
              <dd class="fw-semibold">{{ requestModel.relationship?.name }}</dd>
            </div>
            @if (requestModel.relationship?.code !== "T") {
              <div class="col-lg-3 col-sm-6">
                <dt class="small fw-700">Titular</dt>
                <dd class="fw-semibold">{{ requestModel.holder?.names }} {{ requestModel.holder?.surname }} {{ requestModel.holder?.lastname }}</dd>
              </div>
            }
          </dl>

          <hr class="my-2">
          <span class="fs-6 fw-700 text-uppercase small">Cuenta Bancaria</span>
          <dl class="row my-2" aria-label="Datos de cuenta bancaria">
            <div class="col-lg-4 col-sm-6">
              <dt class="small fw-700">Banco</dt>
              <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.bank?.name }}</dd>
            </div>
            <div class="col-lg-4 col-sm-6">
              <dt class="small fw-700">Tipo Cuenta</dt>
              <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.accountType?.name }}</dd>
            </div>
            <div class="col-lg-4 col-sm-6">
              <dt class="small fw-700">Número</dt>
              <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.number }}</dd>
            </div>
          </dl>

          @if (requestModel.contract) {
            <hr class="my-2">
            <span class="fs-6 fw-700 text-uppercase small">Póliza Origen</span>
            <dl class="row my-2" aria-label="Datos de póliza de origen">
              <div class="col-lg-6 col-sm-12">
                <dt class="small fw-700">Póliza</dt>
                <dd class="fw-semibold">{{ requestModel.contract.policy?.code }} - {{ requestModel.contract.policy?.entity?.name || requestModel.policy?.entity?.name }}</dd>
              </div>
              <div class="col-lg-6 col-sm-12">
                <dt class="small fw-700">Grupo</dt>
                <dd class="fw-semibold">{{ requestModel.contract.group?.name }}</dd>
              </div>
              <div class="col-lg-4 col-sm-6">
                <dt class="small fw-700">Fecha Vigencia</dt>
              <dd class="fw-semibold">{{ requestModel.contract.dateStart | date: "dd-MM-yyyy": "UTC" }}</dd>
            </div>
            <div class="col-lg-4 col-sm-6">
              <dt class="small fw-700">Capital</dt>
              <dd class="fw-semibold">{{ requestModel.contract.capital | numberPipe }}</dd>
            </div>
            @if (requestModel.dateFinish) {
                <div class="col-lg-4 col-sm-6">
                  <dt class="small fw-700">Fecha Fin Vigencia</dt>
              <dd class="fw-semibold">{{ requestModel.dateFinish | date: "dd-MM-yyyy": "UTC" }}</dd>
            </div>
          }
        </dl>
      }

      @if (!requestModel.dateFinish && requestModel.policy && !isExclusion) {
            <hr class="my-2">
            <span class="fs-6 fw-700 text-uppercase small">Póliza Destino</span>
            <dl class="row my-2" aria-label="Datos de póliza de destino">
              <div class="col-lg-6 col-sm-12">
                <dt class="small fw-700">Póliza</dt>
                <dd class="fw-semibold">{{ requestModel.policy.code }} - {{ requestModel.policy.entity?.name }}</dd>
              </div>
              <div class="col-lg-6 col-sm-12">
                <dt class="small fw-700">Grupo</dt>
                <dd class="fw-semibold">{{ requestModel.group?.name }}</dd>
              </div>
              <div class="col-lg-4 col-sm-6">
                <dt class="small fw-700">Fecha Inicio</dt>
                <dd class="fw-semibold">{{ requestModel.dateStart | date: "dd-MM-yyyy": "UTC" }}</dd>
              </div>
              <div class="col-lg-4 col-sm-6">
                <dt class="small fw-700">Capital</dt>
                <dd class="fw-semibold">{{ requestModel.capital | numberPipe }}</dd>
              </div>
            </dl>
          }
        </div>
      }
    </div>
  }
}

@if (editRequest) {
  <div class="modal-body row" [formGroup]="requestForm" role="form" aria-label="Formulario de edición de solicitud">
    <div class="row">
      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="dateRequest" class="form-label fw-600">Fecha Solicitud</label>
        <input id="dateRequest" type="date" class="form-control form-control-sm" formControlName="dateRequest"
          [attr.aria-required]="true" [class.is-invalid]="requestForm.get('dateRequest')?.touched && requestForm.get('dateRequest')?.invalid">
      </div>
      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="dateExport" class="form-label fw-600">Fecha Exportado</label>
        <input id="dateExport" type="date" class="form-control form-control-sm" formControlName="dateExport">
      </div>
    </div>

    @if (isExclusion) {
    <div class="p-3 text-dark">
      <span class="fs-6 fw-700 text-uppercase small">Datos Personales</span>
      <dl class="row my-2">
        <div class="col-lg-4 col-sm-6">
          <dt class="small fw-700">RUT</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.rut | numberPipe }}-{{ requestModel.insured?.dv }}</dd>
        </div>
        <div class="col-lg-8 col-sm-6">
          <dt class="small fw-700">Nombre Completo</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.names }} {{ requestModel.insured?.surname }} {{ requestModel.insured?.lastname }}</dd>
        </div>
        <div class="col-lg-3 col-sm-6">
          <dt class="small fw-700">Género</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.gender?.code }} - {{ requestModel.insured?.gender?.name }}</dd>
        </div>
        <div class="col-lg-3 col-sm-6">
          <dt class="small fw-700">Nacimiento</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.birthdate | date: 'dd-MM-yyyy': 'UTC' }}</dd>
        </div>
        <div class="col-lg-3 col-sm-6">
          <dt class="small fw-700">Edad</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.age }} años</dd>
        </div>
        <div class="col-lg-3 col-sm-6">
          <dt class="small fw-700">Teléfono</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.phone ? requestModel.insured.phone : "Sin registro" }}</dd>
        </div>
        <div class="col-lg-6 col-sm-12">
          <dt class="small fw-700">Correo</dt>
          <dd class="fw-semibold">{{ (requestModel.insured?.mail == null || requestModel.insured?.mail === '') ? "Sin registro" : requestModel.insured.mail | lowercase }}</dd>
        </div>
        <div class="col-lg-3 col-sm-6">
          <dt class="small fw-700">Tipo Asegurado</dt>
          <dd class="fw-semibold">{{ requestModel.relationship?.name }}</dd>
        </div>
        @if (requestModel.relationship?.code !== "T") {
          <div class="col-lg-3 col-sm-6">
            <dt class="small fw-700">Titular</dt>
            <dd class="fw-semibold">{{ requestModel.holder?.names }} {{ requestModel.holder?.surname }} {{ requestModel.holder?.lastname }}</dd>
          </div>
        }
      </dl>

      <hr class="my-2">
      <span class="fs-6 fw-700 text-uppercase small">Cuenta Bancaria</span>
      <dl class="row my-2">
        <div class="col-lg-4 col-sm-6">
          <dt class="small fw-700">Banco</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.bank?.name }}</dd>
        </div>
        <div class="col-lg-4 col-sm-6">
          <dt class="small fw-700">Tipo Cuenta</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.type_account?.name }}</dd>
        </div>
        <div class="col-lg-4 col-sm-6">
          <dt class="small fw-700">Número</dt>
          <dd class="fw-semibold">{{ requestModel.insured?.account == null ? "Sin registro" : requestModel.insured.account.number }}</dd>
        </div>
      </dl>

      @if (requestModel.contract) {
        <hr class="my-2">
        <span class="fs-6 fw-700 text-uppercase small">Póliza Origen</span>
        <dl class="row my-2">
          <div class="col-lg-6 col-sm-12">
            <dt class="small fw-700">Póliza</dt>
            <dd class="fw-semibold">{{ requestModel.contract.policy?.code }} - {{ requestModel.contract.policy?.entity?.name || requestModel.policy?.entity?.name }}</dd>
          </div>
          <div class="col-lg-6 col-sm-12">
            <dt class="small fw-700">Grupo</dt>
            <dd class="fw-semibold">{{ requestModel.contract.group?.name }}</dd>
          </div>
          <div class="col-lg-4 col-sm-6">
            <dt class="small fw-700">Fecha Vigencia</dt>
            <dd class="fw-semibold">{{ requestModel.contract.dateStart | date: "dd-MM-yyyy": "UTC" }}</dd>
          </div>
          <div class="col-lg-4 col-sm-6">
            <dt class="small fw-700">Capital</dt>
            <dd class="fw-semibold">{{ requestModel.contract.capital | numberPipe }}</dd>
          </div>
          <div class="col-lg-4 col-sm-6">
            <dt class="small fw-700">Fecha Fin Vigencia</dt>
            <dd><input type="date" class="form-control form-control-sm" formControlName="dateFinish"></dd>
          </div>
        </dl>
      }
    </div>
    } @else {
    <div class="row my-3" formGroupName="insured" role="group" aria-label="Datos personales del asegurado">
      <span class="fs-4 fw-600">Datos Personales</span>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredRut" class="form-label fw-600">RUT</label>
        <input id="insuredRut" type="text" class="form-control" formControlName="rut"
          placeholder="Sin puntos ni guión" (blur)="setDigitVerificator()"
          [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('insured.rut')?.touched && requestForm.get('insured.rut')?.invalid) ? 'insuredRutError' : null"
          [class.is-invalid]="requestForm.get('insured.rut')?.touched && requestForm.get('insured.rut')?.invalid">
        @if (requestForm.get('insured.rut')?.touched && requestForm.get('insured.rut')?.invalid) {
          <div id="insuredRutError" class="text-danger small" role="alert">Dato Obligatorio</div>
        }
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label class="form-label fw-600">DV</label>
        <label class="form-control" aria-label="Dígito verificador">{{ requestForm.value.insured?.dv ? requestForm.value.insured.dv : '-' }}</label>
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredBirthdate" class="form-label fw-600">Fecha Nacimiento</label>
        <input id="insuredBirthdate" type="date" class="form-control" formControlName="birthdate"
          [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('insured.birthdate')?.touched && requestForm.get('insured.birthdate')?.invalid) ? 'insuredBirthdateError' : null"
          [class.is-invalid]="requestForm.get('insured.birthdate')?.touched && requestForm.get('insured.birthdate')?.invalid">
        @if (requestForm.get('insured.birthdate')?.touched && requestForm.get('insured.birthdate')?.invalid) {
          <div id="insuredBirthdateError" class="text-danger small" role="alert">Dato Obligatorio</div>
        }
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredGender" class="form-label fw-600">Género</label>
        <ng-select id="insuredGender" [items]="listGenders" bindLabel="name" bindValue="_id" formControlName="genderId"
          [attr.aria-required]="true"
          [class.is-invalid]="requestForm.get('insured.genderId')?.touched && requestForm.get('insured.genderId')?.invalid">
        </ng-select>
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredNames" class="form-label fw-600">Nombres</label>
        <input id="insuredNames" type="text" class="form-control" formControlName="names"
          [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('insured.names')?.touched && requestForm.get('insured.names')?.invalid) ? 'insuredNamesError' : null"
          [class.is-invalid]="requestForm.get('insured.names')?.touched && requestForm.get('insured.names')?.invalid">
        @if (requestForm.get('insured.names')?.touched && requestForm.get('insured.names')?.invalid) {
          <div id="insuredNamesError" class="text-danger small" role="alert">Dato Obligatorio</div>
        }
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredSurname" class="form-label fw-600">Apellido Paterno</label>
        <input id="insuredSurname" type="text" class="form-control" formControlName="surname"
          [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('insured.surname')?.touched && requestForm.get('insured.surname')?.invalid) ? 'insuredSurnameError' : null"
          [class.is-invalid]="requestForm.get('insured.surname')?.touched && requestForm.get('insured.surname')?.invalid">
        @if (requestForm.get('insured.surname')?.touched && requestForm.get('insured.surname')?.invalid) {
          <div id="insuredSurnameError" class="text-danger small" role="alert">Dato Obligatorio</div>
        }
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredLastname" class="form-label fw-600">Apellido Materno</label>
        <input id="insuredLastname" type="text" class="form-control" formControlName="lastname"
          [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('insured.lastname')?.touched && requestForm.get('insured.lastname')?.invalid) ? 'insuredLastnameError' : null"
          [class.is-invalid]="requestForm.get('insured.lastname')?.touched && requestForm.get('insured.lastname')?.invalid">
        @if (requestForm.get('insured.lastname')?.touched && requestForm.get('insured.lastname')?.invalid) {
          <div id="insuredLastnameError" class="text-danger small" role="alert">Dato Obligatorio</div>
        }
      </div>

      <div class="mt-2 col-lg-3 col-sm-6">
        <label for="insuredPhone" class="form-label fw-600">Teléfono de Contacto</label>
        <input id="insuredPhone" type="tel" class="form-control" formControlName="phone" placeholder="912345678">
      </div>

      <div class="mt-2 col-lg-6 col-sm-12">
        <label for="insuredMail" class="form-label fw-600">Correo</label>
        <input id="insuredMail" type="email" class="form-control" formControlName="mail" placeholder="usuario@adventistas.org">
      </div>
    </div>

    <div class="row my-3" formGroupName="account" role="group" aria-label="Datos bancarios">
      <span class="fs-4 fw-600">Datos Bancarios</span>

      <div class="mt-2 col-lg-6 col-sm-12">
        <label for="accountBank" class="form-label fw-600">Banco</label>
        <ng-select id="accountBank" class="select-modal" [items]="listBanks" bindLabel="name" bindValue="_id" formControlName="bankId"></ng-select>
      </div>
      <div class="mt-2 col-lg-6 col-sm-12">
        <label for="accountType" class="form-label fw-600">Tipo Cuenta</label>
        <ng-select id="accountType" class="select-modal" [items]="listTypeAccount" bindLabel="name" bindValue="_id" formControlName="accountTypeId"></ng-select>
      </div>
      <div class="mt-2 col-lg-6 col-sm-12">
        <label for="accountNumber" class="form-label fw-600">Número de Cuenta</label>
        <input id="accountNumber" type="text" class="form-control" formControlName="number">
      </div>
    </div>

    @if (requestForm.value.contract?.policy) {
      <div class="row my-3" formGroupName="contract" role="group" aria-label="Póliza actual">
        <span class="fs-4 fw-600">Póliza Actual</span>

        <div class="mt-2 col-lg-6 col-sm-12">
          <label class="form-label fw-600">Póliza</label>
          <label class="form-control form-control-sm">{{ requestForm.value.contract?.policy?.name }}</label>
        </div>
        <div class="mt-2 col-lg-6 col-sm-12">
          <label class="form-label fw-600">Grupo</label>
          <label class="form-control form-control-sm">{{ requestForm.value.contract?.group?.name }}</label>
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label class="form-label fw-600">Capital</label>
          <label class="form-control form-control-sm">{{ requestForm.value.contract?.capital }}</label>
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label class="form-label fw-600">Fecha Vigencia</label>
          <label class="form-control form-control-sm">{{ requestForm.value.contract?.date_start }}</label>
        </div>

      </div>
    }

    @if (!requestForm.value.dateFinish) {
      <div class="row my-3" formGroupName="transfer" role="group" aria-label="Póliza destino">
        <span class="fs-4 fw-600">Póliza Destino</span>

        <div class="mt-2 col-lg-9 col-sm-12">
          <label for="transferEntity" class="form-label fw-600">Campo</label>
          <ng-select id="transferEntity" class="select-modal" [items]="listOffices" bindValue="_id" bindLabel="name"
            formControlName="entityId" (change)="onEntityChange()" [appendTo]="'body'"
            [attr.aria-required]="true"></ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label for="transferPolicy" class="form-label fw-600">Póliza</label>
          <ng-select id="transferPolicy" class="select-modal" [items]="listPolicies" bindValue="_id" bindLabel="code"
            formControlName="policyId" (change)="onPolicyChange()" [appendTo]="'body'"
            [attr.aria-required]="true"></ng-select>
        </div>
        <div class="mt-2 col-lg-6 col-sm-6">
          <label for="transferGroup" class="form-label fw-600">Grupo</label>
          <ng-select id="transferGroup" class="select-modal" [items]="listGroups" bindValue="_id" bindLabel="name"
            formControlName="groupId" [appendTo]="'body'" [attr.aria-required]="true"></ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label for="transferRelationship" class="form-label fw-600">Tipo Asegurado</label>
          <ng-select id="transferRelationship" [items]="listInsuredTypes" bindLabel="name" bindValue="_id"
            formControlName="relationshipId" [attr.aria-required]="true"></ng-select>
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label for="transferCapital" class="form-label fw-600">Capital</label>
          <input id="transferCapital" type="text" class="form-control" formControlName="capital"
            [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('transfer.capital')?.touched && requestForm.get('transfer.capital')?.invalid) ? 'transferCapitalError' : null"
            [class.is-invalid]="requestForm.get('transfer.capital')?.touched && requestForm.get('transfer.capital')?.invalid">
          @if (requestForm.get('transfer.capital')?.touched && requestForm.get('transfer.capital')?.invalid) {
            <div id="transferCapitalError" class="text-danger small" role="alert">Dato Obligatorio</div>
          }
        </div>
        <div class="mt-2 col-lg-3 col-sm-6">
          <label for="transferDateStart" class="form-label fw-600">Fecha Inicio Vigencia</label>
          <input id="transferDateStart" type="date" class="form-control" formControlName="dateStart"
            [attr.aria-required]="true" [attr.aria-describedby]="(requestForm.get('transfer.dateStart')?.touched && requestForm.get('transfer.dateStart')?.invalid) ? 'transferDateStartError' : null"
            [class.is-invalid]="requestForm.get('transfer.dateStart')?.touched && requestForm.get('transfer.dateStart')?.invalid">
          @if (requestForm.get('transfer.dateStart')?.touched && requestForm.get('transfer.dateStart')?.invalid) {
            <div id="transferDateStartError" class="text-danger small" role="alert">Dato Obligatorio</div>
          }
        </div>
      </div>
    }
    }
  </div>
}

@if (showFooter) {
  <div class="modal-footer" role="group" aria-label="Acciones del formulario">
    <button class="btn btn-secondary btn-sm" aria-label="Cerrar modal" (click)="dismiss()">Cerrar</button>
    @if (editRequest) {
      <button class="btn btn-outline-danger btn-sm" aria-label="Cancelar edición" (click)="cancel()">Cancelar</button>
      <button [disabled]="requestForm.invalid" class="btn btn-success btn-sm" aria-label="Guardar cambios" (click)="saveChanges()">Guardar</button>
    } @else {
      @if (canEdit) {
        <button class="btn btn-outline-info btn-sm" aria-label="Editar datos de la solicitud" (click)="setEditRequest()">Editar Datos</button>
      }
    }
    @if (!editRequest && canApprove) {
      <button class="btn btn-outline-danger btn-sm" aria-label="Rechazar solicitud" (click)="approval(false)">Rechazar</button>
      <button class="btn btn-success btn-sm" aria-label="Aceptar solicitud" (click)="approval(true)">Aceptar</button>
    }
  </div>
}
